import { useEffect, useState } from "react";
import { translate } from "../localization/translateService";

const useTranslation = (key, commonNamespace = false) => {
  const [translation, setTranslation] = useState("");

  useEffect(() => {
    const fetchTranslation = async () => {
      const translatedValue = await translate(key, commonNamespace);
      setTranslation(translatedValue);
    };

    fetchTranslation();
  }, [key, commonNamespace]);

  return translation;
};

export default useTranslation;
